import {Locale} from '@/utils/constants'

// The 45 top-level class names per locale — ~18 kB for all nine, against ~1.1 MB for
// the full goods-and-services corpus that getGoodsAndServicesByLanguage reads.
// Components that only render a class label ("Class 25 - Clothing, footwear, headgear")
// belong here; only callers that need the groups/items trees should reach for the corpus.
//
// Generated from those same source files by
// scripts/update-goods-and-services-registration-form/generateClassNames.js.
const classNamesByLocale: Record<
  Locale,
  Record<number, string>
> = require('public/goods-and-services/class-names.json')

export const getGSClassNamesByLanguage = (language: Locale): Record<number, string> =>
  classNamesByLocale[language] ?? classNamesByLocale[Locale.en] ?? {}
